import React from 'react';
import ReactDOM from 'react-dom/client';

import JoinfromCalendarPage from '../src/components/app/webex/join-from-calendar/JoinFromCalendarPage.tsx';

const reactRootEl = document.querySelector('#react-root');

if (reactRootEl) {
  ReactDOM.createRoot(reactRootEl).render(<JoinfromCalendarPage />);
}
